export const Apis = "https://devapi.nxgnportal.com";
export const Authapi = "https://devuser.nxgnportal.com";

//export const Apis = "https://localhost:7170";
//export const Authapi = "https://localhost:7184";
